//
//
//
//
//
//
//

export default {
  name: 'BaseStars',

  props: {
    rating: {
      type: [String, Number],
      default: 5,
      validator(value) {
        return Number(value) <= 5
      }
    }
  },

  computed: {
    style() {
      return `width: ${this.rating * 20}%`
    }
  }
}
